import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension, NCZIReference } from '../Interfaces/ncziTypes';

export type WritePatientDPNParams = PatientCommandParams & {
	confirmation: {
		createdAt: string;
		versionStatus: string;
		sensitivity: number;
		uncertaintyExpressed: boolean;
		incapableFrom: string;
		capableFrom: string | undefined;
		issueDate: string;
		treatmentAbroad: boolean | undefined;
		note: string | undefined;
		outings:
			| {
					allowedOutings: {
						dateFrom: string;
						timeFrom: string;
						timeTo: string;
					}[];
			  }
			| undefined;
		placeOfStay:
			| {
					note: string | undefined;
					floor: string | undefined;
					apartmentNumber: string | undefined;
					address: {
						street: string;
						descriptiveNumber: string;
						guideNumber: string | undefined;
						country: string;
						city: string;
						postCode: string;
					};
			  }
			| undefined;
		incapableReason: {
			reason: NCZIReference;
			alcoholConsumption: boolean | undefined;
			validFrom: string | undefined;
		};
		incapableDuration: {
			anticipatedTerminationDate: string;
			note: string | undefined;
		};
		insuranceExemption: NCZIExtension[] | undefined;
		diagnosis: {
			code: NCZIReference;
			validFrom: string | undefined;
		};
		changeDate: string;
		phone: string | undefined;
		previousVersion: NCZIExtension | undefined;
	};
};

export const WritePatientDPN = (params: WritePatientDPNParams): Command => {
	return {
		operation: 'ZapisPotvrdenieDPN_v1',
		params,
	};
};
